import React, { useContext, useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import firebase from '../firestore';
import { AuthContext } from '../components/AuthContext'
import Loading from '../components/Loading'

const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
    const [loading, setLoading] = useState(true)
    const [currentUser, setCurrentUser] = useContext(AuthContext)
    useEffect(() => {
        if (!currentUser.pending) {
            setLoading(false)
        }
    }, [currentUser])

    return (
        <Route
            {...rest}
            render={routeProps => {
                if (loading) {
                    return <Loading />
                }
                return (
                    !!currentUser.user ? (
                        <RouteComponent {...routeProps} />
                    ) : (
                            <Redirect to={"/"} />
                        )
                )
            }
            }
        />
    );
};


export default PrivateRoute